import React, { useState } from "react";
import { Space, Table, Row, Col, Button, message } from "antd";
import CriminalCasesModal from "./CriminalCasesModal";
import { removeCriminalCases } from "../../../../../services/vendorProfile.services";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import { CriminalLitigationColumns } from "../../../../PQQ/tableColumns";

const CriminalCases = (props) => {
  const [visible, setVisible] = useState(false);
  const [editTable, setEditTable] = useState(null);

  const openModal = (action) => {
    setVisible(true);
    setEditTable(action);
  };

  const refreshPage = () => {
    props.fetchCriminalCases(props.vendorId);
  };

  const removeColumn = (id) => {
    removeCriminalCases({
      id: id,
      vendor_id: props.vendorId,
    })
      .then((response) => {
        refreshPage();
        message.success(response.data.message);
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  };

  const columns = [
    ...CriminalLitigationColumns,
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ ...record, form_status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  return (
    <Row>
      <Col span={22} offset={1}>
        <Button
          onClick={openModal}
          type="secondary"
          style={{
            marginBottom: 16,
          }}
        >
          Add Litigation
        </Button>
      </Col>
      <Col span={22} offset={1}>
        <Table
          size="small"
          columns={columns}
          dataSource={props.data}
          pagination={false}
          scroll={{ x: 800 }}
        />
      </Col>
      {visible && (
        <CriminalCasesModal
          setVisible={setVisible}
          title="Add Criminal Litigation"
          vendorId={props.vendorId}
          editTable={editTable}
          refresh={refreshPage}
        />
      )}
    </Row>
  );
};

export default CriminalCases;
